(function () {

    'use strict';
    angular.module('app')
        .controller('editAccountController', ['$scope', '$rootScope', '$location', '$routeParams', '$ngBootbox', 'accountsService', 'clientService', 'permissionsService', '_', editAccountController]
        );

    function editAccountController($scope, $rootScope, $location, $routeParams, $ngBootbox, accountsService, clientService, permissionsService, _) {


        $scope.model = {};
        $scope.model.googleAuthenticatorBarcodeUrl = '';
        $scope.model.googleAuthenticatorSecretKey = '';
        $scope.model.googleAuthenticatorVerificationError = '';
        $scope.model.IpAuthentication = {};
        $scope.model.IpAuthentication.IpAddress = '';
        $scope.model.pendingRequests = [];
        $scope.model.SecurityQuestions = [];
        $scope.model.apps = [];

        $scope.getSecurityQuestions = function () {
            accountsService.getSecurityQuestions(false)
                .then(function (response) {

                    $scope.model.SecurityQuestions = response;
                    if (!$scope.model.SecurityQuestionId || $scope.model.SecurityQuestionId === 0)
                        $scope.model.SecurityQuestionId = $scope.model.SecurityQuestions[0].id;
                });
        };
        $scope.getGoogleAuthenticatorBarcode = function () {
            // Load Security Questions also
            $scope.getSecurityQuestions();

            accountsService.getGoogleAuthenticatorBarcode()
                .then(function (response) {
                    $scope.model.googleAuthenticatorBarcodeUrl = response.barcodeUrl;
                    $scope.model.googleAuthenticatorSecretKey = response.secretKey;
                });
        };

        function impersonate(userId) {

            $location.url('/impersonate/' + userId);
        }

        function loadOAuthClientsForAccount() {
            permissionsService.GetAllClientsforAccount($scope.model.id)
                .then(function(response) {
                    $scope.model.apps = response;
                });
        }

        $scope.impersonate = impersonate;

        $scope.unlockAccount = function () {
            accountsService.unlockAccount($scope.model.id).then(function () {
                $scope.model.isAccountLockedOut = false;
            });
        };

        $scope.verifyGoogleAuthenticator = function () {

            if ($scope.model.SecurityQuestionAnswer && $scope.model.SecurityQuestionAnswer.length > 1) {
                if ($scope.model.googleAuthenticatorCode && $scope.model.googleAuthenticatorCode.length > 5) {
                    
                    accountsService
                        .verifyGoogleAuthenticator($scope.model.googleAuthenticatorCode,
                            $scope.model.googleAuthenticatorSecretKey,
                            $scope.model.SecurityQuestionId,
                            $scope.model.SecurityQuestionAnswer,
                            $scope.model.encryptedAccountId)
                        .then(function (response) {
                            if (response.isValid) {
                                $scope.model.isGoogleAuthenticatorEnabled = true;
                                $scope.submit();
                            } else
                                $scope.model
                                    .googleAuthenticatorVerificationError =
                                    'Unfortunately the code you entered is not valid. Please try again.';
                        });
                } else {
                    $scope.model
                        .googleAuthenticatorVerificationError =
                        'Please enter a valid two-factor authenticator code.';
                }

            } else {
                $scope.model
                    .googleAuthenticatorVerificationError =
                    'Please select a Security Question and enter an answer.';
            }
        };
        $scope.authenticationModeChange = function () {
            if ($scope.model.selectedAuthenticationMode === 1) {
                $scope.model.ipAuthentication = false;

                // Load the barcode if they have previously authenticated it
                if (!$scope.model.isGoogleAuthenticatorEnabled)
                    $scope.getGoogleAuthenticatorBarcode();
            } else {
                $scope.model.isGoogleAuthenticatorEnabled = false;

                $scope.model.ipAuthentication = true;
            }

        };
        $scope.navigateToCompany = function (companyId) {
            $location.url('/company/' + companyId);
        };
        $scope.submit = function () {

            $scope.model.submitted = true;
            if (!$scope.editAccountForm.$valid) {
                return;
            }

            $scope.model.working = true;


            var account = {
                id: $scope.model.id,
                firstName: $scope.model.firstName,
                lastName: $scope.model.lastName,
                email: $scope.model.email,
                companyName: $scope.model.companyName,
                searchNumber: $scope.model.searchNumber,
                jobTitle: $scope.model.jobTitle,
                topbarMode: $scope.model.topbarMode,
                type: $scope.model.type,
                ipAuthentication: $scope.model.ipAuthentication,
                hideTopBar: $scope.model.hideTopBar,
                defaultDashboard: $scope.model.defaultDashboard,
                defaultProduct: $scope.model.defaultProduct.type,
                isGoogleAuthenticatorEnabled: $scope.model.isGoogleAuthenticatorEnabled

            };

            // SecurityQuestionId: $scope.model.SecurityQuestionId,
            // SecurityQuestionAnswer: 

            $scope.model.complete = false;

            accountsService.updateAccount(account)
                .then(function () {
                    $scope.model.working = false;

                    $scope.model.complete = true;
                    $scope.model.success = true;

                    if ($scope.model.authenticatedAccountId === account.id) {

                        $rootScope.warnAboutAuthenticator = (account.type == AccountType.Admin ||
                            account.type == AccountType.SuperAdmin ||
                            account.type == AccountType.Partner ||
                            account.type == AccountType.PartnerSuperAdmin) &&
                            !account.isGoogleAuthenticatorEnabled;


                    }
                },
                    function (response) {
                        $scope.model.working = false;

                        $scope.model.error = response.errors[0].message;
                        $scope.model.complete = true;
                        $scope.model.success = false;
                    });
        };

        $scope.changePassword = function () {
            $location.url('/account/password/change');
        };
        $scope.adminChangePassword = function () {
            $location.url('/account/password/reset/' + $scope.model.id);
        };
        $scope.convertToInt = function (id) {
            return parseInt(id, 10);
        };

        $scope.getPendingRequests = function () {

            if ($scope.model.isAdmin) {
                accountsService.getPendingRequests($scope.model.id)
                    .then(function (response) {
                        $scope.model.pendingRequests = response;
                    });
            }


        };
        $scope.AddIpAddress = function () {
            $scope.model.working = true;

            if ($scope.model.IpAuthentication && $scope.model.IpAuthentication.IpAddress) {
                accountsService.AddIpAddress($scope.model.IpAuthentication.IpAddress, $scope.model.id)
                    .then(function (response) {
                        $scope.model.IpAuthentication.IpAddress = ''; 
                    });
            }

            $scope.model.working = false;
        };

        $scope.loadClients = function () {


            clientService.getClients()
                .then(function (response) {
                    $scope.model.Clients = [];

                    response.forEach(function (client) {

                        if (client.clientDetails.length > 0) {
                            client.attachClientDetailsId = client.clientDetails[0].id;
                            client.attachUsername = '';
                            client.attachPassword = '';
                        }

                        // Setup Default product drop down
                        if (client.type === $scope.model.defaultProduct)
                            $scope.model.defaultProduct = client;

                        if (client.id === gatorClients.Express) {
                            client.ClientAccounts = $scope.model.GatorExpressAccounts;

                        } else if (client.id === gatorClients.Mail) {
                            client.ClientAccounts = $scope.model.GatorMailAccounts;

                        } else if (client.id === gatorClients.Social) {
                            client.ClientAccounts = $scope.model.GatorSocialAccounts;

                        } else if (client.id === gatorClients.Leads) {
                            client.ClientAccounts = $scope.model.GatorLeadsAccounts;

                        } else if (client.id === gatorClients.Workflow) {
                            client.ClientAccounts = $scope.model.GatorWorkflowAccounts;

                        } else if (client.id === gatorClients.Docs) {
                            client.ClientAccounts = $scope.model.GatorDocsAccounts;
                        }
                        else if (client.id === gatorClients.Survey) {
                            client.ClientAccounts = $scope.model.GatorSurveyAccounts;
                        }
                        else if (client.id === gatorClients.SendForensics) {
                            client.ClientAccounts = $scope.model.GatorForensicsAccounts;
                        }

                        // does the client have a company enviroment
                        client.hasEnviroment = false;
                        client.availableClients = [];

                        for (var i = 0; i < $scope.model.company.environments.length; i++) {
                            var localEnv = $scope.model.company.environments[i];

                            if (localEnv.ssoClient.type === client.type) {

                                client.hasEnviroment = true;

                                var enviroments = _.where(client.ClientAccounts, { uniqueId: localEnv.environment });

                                // the user is not already registered to this account 
                                // enable adding
                                if (enviroments.length === 0) {
                                    client.availableClients.push(localEnv);
                                }

                            }
                        }

                        if (client.id !== gatorClients.SignOn && !client.isHidden)
                            $scope.model.Clients.push(client);
                    });

                });
        };

        $scope.createAccount = function (enviroment, isAdmin) {

            accountsService.addEnvironment($scope.model.id, enviroment, isAdmin)
                .then(function (response) {
                    if (response.errors.length > 0) {
                        var errors = [];

                        // an error occured alert the user
                        angular.forEach(response.errors,
                            function (value) {
                                this.push(value.message);
                            },
                            errors);

                        var errorTxt = errors.join('<br/>');

                        $ngBootbox.alert(errorTxt)
                            .then(function () {
                                console.log('Alert closed');
                            });

                    } else {
                        // we need to reload the user
                        activate();
                    }
                });

        };

        activate();

        $scope.deactivateAccount = function () {
            accountsService.deactivate($routeParams.accountId).then(function () {
                $scope.model.deactivated = true;
            });
        }

        $scope.reactivateAccount = function () {
            accountsService.reactivate($routeParams.accountId).then(function () {
                $scope.model.deactivated = false;
            });
        }

        $scope.RemoveApp = function(app) {
            permissionsService.DeleteClientforAccount(app.connectiondId)
                .then(function (response) {
                    if (response === true) {
                        loadOAuthClientsForAccount();
                    }
                });
        }

        

        $scope.FormatDate = function(date) {
            var d = new Date(date);
            var month = '' + (d.getMonth() + 1);
            var day = '' + d.getDate();
            var year = d.getFullYear();
            var hour = d.getHours();
            var minutes = d.getMinutes();

            if (month.length < 2) month = '0' + month;
            if (day.length < 2) day = '0' + day;
            if (hour.length < 2) hour = '0' + hour;
            if (minutes.length < 2) minutes = '0' + minutes;

            return [[year, month, day].join('-'),[hour, minutes].join(':')].join(" ");
        }

        function activate() {
            accountsService.getAccount($routeParams.accountId)
                .then(function (response) {
                    $scope.model = response;
                    $scope.model.type = $scope.model.type.toString();

                    if ($scope.model.isGoogleAuthenticatorEnabled)
                        $scope.model.selectedAuthenticationMode = 1;
                    else
                        $scope.model.selectedAuthenticationMode = 0;


                    $scope.model.GatorExpressAccounts = [];
                    $scope.model.GatorMailAccounts = [];
                    $scope.model.GatorSocialAccounts = [];
                    $scope.model.GatorLeadsAccounts = [];
                    $scope.model.GatorWorkflowAccounts = [];
                    $scope.model.GatorDocsAccounts = [];
                    $scope.model.GatorSurveyAccounts = [];
                    $scope.model.GatorForensicsAccounts = [];


                    var clientUsers = response.ssoClientUsers;

                    if (clientUsers) {
                        for (var i = 0; i < clientUsers.length; i++) {
                            var linkedAccount = clientUsers[i];

                            if (linkedAccount.ssoClientId === gatorClients.Express) {
                                $scope.model.GatorExpressAccounts.push(linkedAccount);
                            } else if (linkedAccount.ssoClientId === gatorClients.Mail) {
                                $scope.model.GatorMailAccounts.push(linkedAccount);
                            } else if (linkedAccount.ssoClientId === gatorClients.Social) {
                                $scope.model.GatorSocialAccounts.push(linkedAccount);
                            } else if (linkedAccount.ssoClientId === gatorClients.Leads) {
                                $scope.model.GatorLeadsAccounts.push(linkedAccount);
                            } else if (linkedAccount.ssoClientId === gatorClients.Workflow) {
                                $scope.model.GatorWorkflowAccounts.push(linkedAccount);
                            } else if (linkedAccount.ssoClientId === gatorClients.Docs) {
                                $scope.model.GatorDocsAccounts.push(linkedAccount);
                            } else if (linkedAccount.ssoClientId === gatorClients.Survey) {
                                $scope.model.GatorSurveyAccounts.push(linkedAccount);
                            } else if (linkedAccount.ssoClientId === gatorClients.SendForensics) {
                                $scope.model.GatorForensicsAccounts.push(linkedAccount);
                            }

                        }
                        $scope.loadClients();
                        $scope.getPendingRequests();
                    }

                    accountsService.getAuthenticatedAccount()
                        .then(function (response) {
                            $scope.model.isAdmin = (response.accountType === AccountType.Admin || response.accountType === AccountType.SuperAdmin);
                            $scope.model.isPartnerAdmin = (response.accountType === AccountType.Partner || response.accountType === AccountType.PartnerSuperAdmin) && $scope.model.company.partnerCode === response.partnerCode;
                            $scope.model.isPartnerSuperAdmin = response.accountType === AccountType.PartnerSuperAdmin && $scope.model.company.partnerCode === response.partnerCode;
                            $scope.model.isSuperAdmin = (response.accountType === AccountType.SuperAdmin);
                            $scope.model.isCompanyAdmin = response.accountType === AccountType.Company && $scope.model.company.id === response.companyId;
                            $scope.model.authenticatedAccountId = response.accountId;
                            $scope.model.companyId = response.companyId;
                            $scope.model.authenticatedAccountRole = response.accountType;
                            $scope.model.isImpersonating = response.isImpersonating;
                        });

                    loadOAuthClientsForAccount();

                });
        };
    }
})();